import Header from "./components/Header";
import Hero from "./components/Hero";
import BlumenauBanner from "./components/BlumenauBanner";
import PricingSection from "./components/PricingSection";
import HowItWorks from "./components/HowItWorks";
import FeaturesSection from "./components/FeaturesSection";
import FAQ from "./components/FAQ";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <BlumenauBanner />
        <PricingSection />
        <HowItWorks />
        <FeaturesSection />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}